import * as types from '../ActionTypes/MetaActionTypes';
import { replace } from 'react-router-redux';
import { takeLatest, put, call } from 'redux-saga/effects';
import { CONFIRM_RESET_PASSWORD } from '../ActionTypes/FormActionTypes';
import { startSubmit, stopSubmit } from 'redux-form';
import { MetaActionCreators } from '../ActionCreators/MetaActionCreators';
import axios from 'axios';
import { user } from '../../BusinessLogic/Network/API/UserApi';

export class MetaSaga {
    static *updatePassword({ payload, meta: { token } }) {
        try {
            yield put(startSubmit(CONFIRM_RESET_PASSWORD));
            const _user = user.create();
            const { status } = yield call(axios, _user.updatePassword(payload, token));

            if (status === 200) {
                yield put(replace('/password-updated'));
            }
            yield put(MetaActionCreators.setPasswordSuccess());
            yield put(stopSubmit(CONFIRM_RESET_PASSWORD));
        } catch (error) {
            if (error.response && error.response.status === 404) {
                yield put(replace('/'));
            }
            yield put(stopSubmit(CONFIRM_RESET_PASSWORD));
        }
    }
}

export function* saga() {
    yield takeLatest(types.SET_PASSWORD_REQUEST, MetaSaga.updatePassword);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/MetaSaga.js